import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController } from 'ionic-angular';
import { MenuServices } from '../../menu/services';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../globals';
import { ComboCreateCustomizeViewPage } from '../combo-view/combo-create-customize-view';
import { ComboServices } from '../services';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
/**
 * Generated class for the MenuListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-combo-list',
    templateUrl: 'combo-list.html',
})
export class ComboListPage {
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' },
        { prop: 'precio', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(
        public loadingCtrl: LoadingController,
        public menuServices: MenuServices,
        public translate: TranslateService,
        public globals: Globals,
        public navCtrl: NavController,
        public comboServices: ComboServices) {
        this.menuServices.searchbar_text = '';
        if (this.globals.checkLimitsByLicense('daily_menu', 'analitycs')) {
            this.menuServices.analyticsGetMostSoldMenu();
            this.menuServices.analyticsGetHighestCommercialMarginMenu();
            this.menuServices.analyticsGetMenusSoldToday();
        }
    }

    /**********************************************************/
    /*                          INIT                          */
    /**********************************************************/

    ionViewWillEnter() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-cargando-menus')
        });
        loadingPopup.present();
        this.menuServices.getPagesCombos(0);
        this.menuServices.page_active_combos = 1;
        // Los tags ya se cargan al inicio de la app en getAllTags()
        this.menuServices.menu_lang = this.globals.restaurant.lang;
        this.menuServices.filterCombo(this.menuServices.searchbar_text);
        loadingPopup.dismiss();
    }

    /**********************************************************/
    /*                         NAVCTRL                        */
    /**********************************************************/

    openView(menu) {
        if (menu._active) {
            this.navCtrl.push(ComboCreateCustomizeViewPage, {
                menu_uid: menu.UID,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    /**********************************************************/
    /*                        FUNCIONES                       */
    /**********************************************************/

    profitFoodCost(price, extra, _foodcost) {
        /*
 var foodcost = parseFloat(extra) + parseFloat(_foodcost);
        */

        //Quitamos el tax del precio
        price = this.globals.createSubTotal(price, this.globals.RESTAURANT_TAX);
        return 100 - this.globals.regla3(parseFloat(price), _foodcost);
    }

    clickElement(event) {
        if (event.type == 'click') {
            this.openView(event.row);
        }
    }

    onSort(event) {
        var combos_array = [];
        if (this.menuServices.filteredCombosActive) {
            combos_array = this.menuServices.filteredCombos;
        } else {
            combos_array = this.menuServices.combos_array;
        }

        switch (event.column.name) {
            case 'name':
                if (event.newValue == 'asc') {
                    combos_array.sort((a, b) => this.globals.nameLangSelectMenu(a).localeCompare(this.globals.nameLangSelectMenu(b)));
                } else {
                    combos_array.sort((a, b) => this.globals.nameLangSelectMenu(b).localeCompare(this.globals.nameLangSelectMenu(a)));
                }
                break;
            case 'precio':
                if (event.newValue == 'asc') {
                    combos_array.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
                } else {
                    combos_array.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
                }
                break;
        }

        if (this.menuServices.filteredCombosActive) {
            this.menuServices.filteredCombos = combos_array;
            this.menuServices.filteredCombos = [...this.menuServices.filteredCombos];
        } else {
            this.menuServices.combos_array = combos_array;
            this.menuServices.combos_array = [...this.menuServices.combos_array];
        }
    }

    getRowClass(row) {
        return {
            'not-active': row._active === false
        };
    }
}


// WEBPACK FOOTER //
// ./src/pages/combo/combo-list/combo-list.ts